import { useEffect, useRef, useState } from "react";
import { Instagram } from "lucide-react";

const REEL = "https://www.instagram.com/reel/DfPEbWakuuO/";
const SCRIPT_SRC = "https://www.instagram.com/embed.js";

const loadScript = () => new Promise((resolve, reject) => {
  if (window.instgrm) { resolve(); return; }
  let s = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
  if (!s) {
    s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    document.body.appendChild(s);
  }
  s.addEventListener("load", () => resolve());
  s.addEventListener("error", () => reject());
});

export const InstagramReel = () => {
  const ref = useRef(null);
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    let alive = true;
    loadScript().then(() => { window.instgrm?.Embeds.process(); }).catch(() => {});
    const iv = setInterval(() => {
      if (alive && ref.current?.querySelector("iframe")) { setRendered(true); clearInterval(iv); }
    }, 500);
    return () => { alive = false; clearInterval(iv); };
  }, []);

  return (
    <section data-testid="instagram-reel-section" className="pt-10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <h2 className="text-center font-display text-2xl sm:text-3xl font-black uppercase text-white">Se Novemberkåsan i action</h2>
        <div ref={ref} className="mx-auto mt-5 w-full max-w-[540px]">
          <blockquote className="instagram-media" data-instgrm-permalink={REEL} data-instgrm-version="14"
            style={{ background: "#FFF", border: 0, borderRadius: 12, margin: 0, maxWidth: 540, minWidth: 0, width: "100%" }} />
        </div>
        {!rendered && (
          <div className="mt-4 text-center">
            <a href={REEL} target="_blank" rel="noopener" data-testid="instagram-reel-fallback"
              className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-5 py-3 text-sm font-bold uppercase tracking-widest text-black hover:bg-amber-400 transition-colors">
              <Instagram className="w-4 h-4" /> Se videon på Instagram
            </a>
          </div>
        )}
      </div>
    </section>
  );
};
